export default function PaletteOptimizationModal({
  customPalette,
  optimizationThreshold,
  onOptimizationThresholdChange,
  onOptimize,
  pendingConversionBrand,
  onPendingConversionBrandChange,
  onConvertPaletteBrand,
  isPro,
  onClose,
}) {
  const isProFeatureDisabled = !isPro;

  return (
    <div className="modal-backdrop">
      <div className="modal settings-modal">
        <div className="modal-header">
          <h2>Palette Optimization</h2>
          <button className="icon-btn" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="modal-body">
          <div className="setting-group">
            <h3>Color Reduction (Optimization)</h3>
            <label htmlFor="optimization-threshold">
              Remove and remap colors used less than this number of stitches:
            </label>
            <input
              id="optimization-threshold"
              type="number"
              value={optimizationThreshold}
              onChange={(event) =>
                onOptimizationThresholdChange(
                  parseInt(event.target.value, 10) || 0
                )
              }
              min="0"
              placeholder="50"
              className="input"
              style={{ marginBottom: "10px" }}
              disabled={isProFeatureDisabled}
            />
            <button
              className="btn btn-primary"
              onClick={() => onOptimize(optimizationThreshold)}
              disabled={customPalette.length < 2 || isProFeatureDisabled}
              title={isProFeatureDisabled ? "Pro feature" : undefined}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              Run Optimization and Reduce Colors
            </button>
            {isProFeatureDisabled && (
              <p className="hint danger">
                Pro Feature: Upgrade to reduce and remap colors automatically.
              </p>
            )}
            <p className="hint">
              Analyzes all layers, removes low-usage colors, and replaces them
              with the closest remaining color. Requires at least two colors in
              My Palette.
            </p>
          </div>

          <hr />

          <div className="setting-group">
            <h3>Palette Conversion</h3>
            <div className="grid2">
              <label htmlFor="conversion-target-brand">
                Convert My Palette to:
              </label>
              <select
                id="conversion-target-brand"
                value={pendingConversionBrand}
                onChange={(event) =>
                  onPendingConversionBrandChange(event.target.value)
                }
                className="select"
                disabled={isProFeatureDisabled}
              >
                <option value="DMC">DMC Threads</option>
                <option value="Anchor">Anchor Threads</option>
              </select>
            </div>
            <button
              className="btn btn-good"
              onClick={() => onConvertPaletteBrand(pendingConversionBrand)}
              disabled={customPalette.length === 0 || isProFeatureDisabled}
              title={isProFeatureDisabled ? "Pro feature" : undefined}
              style={{ width: "100%", marginTop: "10px" }}
            >
              Convert All Colors to {pendingConversionBrand}
            </button>
            {isProFeatureDisabled && (
              <p className="hint danger">
                Pro Feature: Upgrade to convert palettes between thread brands.
              </p>
            )}
            <p className="hint">
              Replaces the Hex/Code/Name of all colors in My Palette with their
              closest match in the selected thread brand. Color indices in the
              pattern remain the same.
            </p>
          </div>

          <hr />

          <div className="setting-group">
            <h3>Dye Lot Simulation (Export Only)</h3>
            <p className="hint">
              Future feature to be implemented. This will add subtle, random
              color variation to the final PNG export to simulate different
              thread dye lots for photorealism.
            </p>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
